/* eslint-disable linebreak-style */
/* eslint-disable prettier/prettier */
import axios from 'axios';

export default (url, fileData) => {
  const instance = axios.create();
  instance.defaults.headers['Content-Type'] = fileData.type;
  delete instance.defaults.headers.common.Authorization;
  return instance.put(`${url}`, fileData);
};
